import React, { useState, useEffect } from "react";
import { Collapse, Modal, Input, Spin, Button, Space } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { deleteRequest, getRequest, postRequest } from "../../../../api/http";
import { toast } from "react-toastify";
import userServiceApi from "../../../../api/userServiceApi";
import axios from "axios";
import "../index.scss";
import replyIcon from "../../../../assets/images/reply-icon.svg";
import deleteIcon from "../../../../assets/images/delete-icon.svg";
import viewIcon from "../../../../assets/images/view-icon.svg";
import downloadIcon from "../../../../assets/images/download-icon.svg";
import DeleteModal from "../../../deleteModal/deleteModal";
import { truncate } from "../../../../utils/helper";

const Enduserfeedback = ({ loading, FeedbackData: feedbackData, reload }) => {
  const [reply, setReply] = useState("");
  const [pdfContent, setPdfContent] = useState(null);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [deleteFeedbackId, setDeleteFeedbackId] = useState("");
  const [deleteFeedbackmodal, setDeleteFeedbackModal] = useState(false);
  const [fileType, setFileType] = useState();
  const [selectedItemId, setSelectedItemId] = useState(null);

  const [groupedUnderPartnerName, setGroupedUnderPartnerName] = useState({})

  useEffect(() => {
    let tempGroupedUnderPartnerName = {}

    feedbackData.forEach(element => {
      if (tempGroupedUnderPartnerName[element.partnerName]) {
        tempGroupedUnderPartnerName[element.partnerName] = [...tempGroupedUnderPartnerName[element.partnerName], element]
      }
      else
        tempGroupedUnderPartnerName[element.partnerName] = [element]
    });

    setGroupedUnderPartnerName(tempGroupedUnderPartnerName)
  }, [feedbackData])


  const handleDelete = async () => {
    try {
      const response = await deleteRequest(
        userServiceApi.deleteFeedback(deleteFeedbackId)
      );

      if (response) {
        toast.success("Feedback deleted successfully");
        setDeleteFeedbackId("");
        setDeleteFeedbackModal(false);
        reload();
      }
    } catch (error) {
      toast.error("Failed to delete feedback");
    }
  };

  const handleDownload = async (feedbackId) => {
    try {
      const authToken = sessionStorage.getItem("token");

      const downloadUrl = userServiceApi.downloadFeedback(feedbackId);
      const response = await axios.get(downloadUrl, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        responseType: "blob",
      });

      if (response) {
        const contentDisposition = response.headers.get("content-disposition");
        const filenameMatch =
          contentDisposition && contentDisposition.match(/filename=(.+?)(;|$)/);
        const fileName = filenameMatch ? filenameMatch[1] : "Feedback.pdf";

        const blob = new Blob([response.data]);
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    } catch (error) {
      // console.log("Error downloading file:", error);
      toast.error("Error downloading file");
    }
  };

  const handleReply = async (feedbackId) => {
    try {
      const formData = new FormData();
      formData.append("adminReply", reply);

      const response = await postRequest(
        userServiceApi.replyEnduserFeedback(feedbackId),
        formData
      );
      if (response) {
        reload();
        toast.success("Reply sent successfully");
        setReply("");
      }
    } catch (error) {
      // console.log("Error sending reply:", error);
      toast.error("Error sending reply");
    }
  };

  const handleViewPDF = async (feedbackId) => {
    try {
      const authToken = sessionStorage.getItem("token");

      const viewUrl = userServiceApi.viewFeedback(feedbackId);
      const response = await axios.get(viewUrl, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        responseType: "blob",
      });

      if (response) {
        setFileType(response.data.type);
        const blob = new Blob([response.data], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(blob);

        setPdfContent(pdfUrl);
        setViewModalVisible(true);
      }
    } catch (error) {
      console.log("Error viewing PDF:", error);
      toast.error("Error viewing PDF");
    }
  };

  const handleDeleteFeedback = (id) => {
    setDeleteFeedbackId(id);
    setDeleteFeedbackModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteFeedbackId("");
    setDeleteFeedbackModal(false);
  };

  const genExtra = (item) => (
    <Space size="middle" style={{ display: "flex", alignItems: "center" }}>
      {item.fileName ? (
        <>
          <img
            src={downloadIcon}
            alt="downloadIcon"
            onClick={(event) => {
              event.stopPropagation();
              handleDownload(item.id);
            }}
          />
          <div className="line" />
          <img
            src={viewIcon}
            alt="viewIcon"
            onClick={(event) => {
              event.stopPropagation();
              handleViewPDF(item.id);
            }}
          />
          <div className="line" />
        </>
      ) : null}
      <img
        src={deleteIcon}
        alt="deleteIcon"
        onClick={(event) => {
          event.stopPropagation();
          handleDeleteFeedback(item.id);
        }}
      />
    </Space>
  );

  const feedbackType = (type) => {
    if (type === "COMMENT") {
      return "Comment";
    } else if (type === "REPORT") {
      return "Bug Report";
    } else if (type === "SUGGESTION") {
      return "Suggestion for improvement";
    }
  };

  const emailFeedbackObj = (feedbackData) => {
    let groupedFeedbackData = feedbackData.reduce((acc, item) => {
      const email = item.email;
      if (!acc[email]) {
        acc[email] = [];
      }
      acc[email].push(item);
      return acc;
    }, {});
    return groupedFeedbackData
  }

  const feedbackCollapsePanels = (feedbackData) => {
    const groupedFeedback = emailFeedbackObj(feedbackData)
    return Object.keys(groupedFeedback).map((email) => {
      return <Collapse.Panel
        key={email}
        header={`${email}`}
        className="collapse-panel-feedback"
      // extra={genExtra(feedbackItems[i])}
      >
        {groupedFeedback[email].map((item) => {
          return <div key={item.id} className="feedback-box">
            <div className="horizontalLineTop"></div>
            <div className="message-box">
              <div className="feedback-title">
                {feedbackType(item.feedbackAboutEnum)}:
                <div className="extra-content">{genExtra(item)}</div>
              </div>
              <div className="message">{item.message}</div>
              {item.fileName && (
                <div
                  className="attachment"
                  onClick={() => {
                    handleViewPDF(item.id);
                  }}
                >
                  {item.fileName}
                </div>
              )}
              {item.adminReply ? (
                <div style={{ marginTop: "10px" }}>
                  <div className="feedback-title">Admin reply:</div>
                  <div className="message">{item.adminReply}</div>
                </div>
              ) : null}
            </div>
            <div className="horizontalLine"></div>
            <div
              className="reply-box"
              onClick={() => {
                setSelectedItemId(item.id);
              }}
            >
              <Input
                className="input-box"
                placeholder="Type your reply here..."
                value={selectedItemId === item.id ? reply : ""}
                onChange={(e) => setReply(e.target.value)}
              />
              {selectedItemId === item.id && reply ? (
                <Button
                  className="replyBtn redBtn"
                  onClick={() => handleReply(item.id)}
                >
                  <img
                    src={replyIcon}
                    alt="reply"
                    style={{ marginRight: "2px" }}
                  />{" "}
                  Reply{" "}
                </Button>
              ) : (
                <Button
                  className="replyBtn redBtn"
                  style={{ opacity: "0.5", cursor: "not-allowed" }}
                >
                  <img
                    src={replyIcon}
                    alt="reply"
                    style={{ marginRight: "2px" }}
                  />{" "}
                  Reply{" "}
                </Button>
              )}
            </div>
            <br />
            {
              item?.adminReplies?.length > 0 && <>

                <div className="horizontalLine"></div>
                <div className="previous-replies-container" >
                  <h3>
                    Previous Replies
                  </h3>
                  {
                    item?.adminReplies.map((reply) => {
                      return <p className="previous-reply-text">{reply}</p>
                    })
                  }
                </div>
              </>
            }
          </div>
        }
        )}
      </Collapse.Panel>
    });
  }

  return (
    <div className="feedback-page">
      <div className="feedback-heading">
        <div className="partner-heading">Feedback List</div>
      </div>
      {
        feedbackData.length === 0 && <div style={{ textAlign: 'center', color: '#8d97a1' }}  > <h3 className="text-black-50">
          No data found</h3> </div>
      }
      <Collapse
        accordion
        expandIconPosition="end"
        bordered={false}
        className="collapse-feedback"
      >
        {Object.keys(groupedUnderPartnerName).map((partnerName, i) => (
          <Collapse.Panel
            key={i}
            header={truncate(partnerName)}
            className="collapse-panel-feedback"
          >
            <Collapse
              accordion
              expandIconPosition="end"
              bordered={false}
              className="collapse-feedback"
            >
              {feedbackCollapsePanels(groupedUnderPartnerName[partnerName]) || (
                <div>No feedback available.</div>
              )}
            </Collapse>
          </Collapse.Panel>
        ))}
      </Collapse>

      <DeleteModal
        openModal={deleteFeedbackmodal}
        message="Are you sure you want to delete feedback?"
        yesClick={handleDelete}
        closeModal={closeDeleteModal}
      />

      <Modal
        title="View Attachment"
        visible={viewModalVisible}
        onCancel={() => setViewModalVisible(false)}
        footer={null}
        className="viewpdf"
        width={800}
      >
        {pdfContent ? (
          fileType === "application/pdf" ? (
            <iframe
              src={pdfContent}
              style={{ width: "100%", height: "600px" }}
              title="PDF Viewer"
            />
          ) : (
            <div className="image-view">
              <img
                src={pdfContent}
                alt="Image"
                style={{ maxWidth: "100%", height: "auto", minWidth: "300px" }}
              />
            </div>
          )
        ) : null}
      </Modal>
    </div>
  );
};

export default Enduserfeedback;
